<template>
    <div class="r-topic-title" :class="{'line-feed': lineFeed,'unset-white-space': unsetWhiteSpace}">
      <!-- <div class="tags" v-if="showTag">
        <Tag v-if="showVerify" color="warning" key="verify">审核中</Tag>
        <Tag v-if="isTop" color="primary" key="top">置顶</Tag>
  
        <template v-if="label && label.length">
          <Tag v-for="{id, title} of label" :key="id" color="success" >{{ title }}</Tag>
        </template>
        
        <Tag v-if="tag" color="primary" key="tag">{{ tag }}</Tag>
        <Tag v-if="topicVoteFlag" color="primary">投票贴</Tag>
      </div> -->
      <!-- <span :class="{'topic-discuss_name': true,'line-two': lineTwo}" v-if="discussName.length > 0" v-for="(item,i) in discussName" :key="i" @click="gotoGambit(item.id)">#{{item.discuss_name}}#</span> -->
      <span class="title" @click="goToTopic" v-html="title"></span>
    </div>
  </template>
  
  <script type="text/javascript">
  import TopicMix from './TopicMix'
  export default {
    name: 'topic-title',
    mixins: [TopicMix],
    props: {
      // 是否换行
      lineFeed: Boolean,
      // 标题
      title: String,
      lineTwo: Boolean,
      unsetWhiteSpace: Boolean,
    },
    computed: {
      // 显示审核中
      showVerify () {
        return this.row.status == 0 && this.row.rough == 0
      }
    },
    watch: {
     
    }
  }
  </script>
  
  <style lang="less" scoped>
  .r-topic-title {
    font-size: .7rem;
    color: #000;
    font-weight: 700;
    margin-bottom: 0.7rem;
  }
  .unset-white-space {
    .title {
      white-space: unset !important;
    }
  }
  //帖子角标下的tag标签bug
  .tags {
    span {
      background-color: rgba(0, 0, 0, 0) !important;
    }
  }
  .topic-discuss_name {
    font-size: 0.75rem;
    color: #d9b581;
    font-weight: 700;
    line-height: 26px;
    margin-right: 3px;
    cursor: pointer;
    margin-right: 8px;
    &.line-two {
      white-space: unset !important;
    }
  }
  
  </style>